import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import {
  getSingleProduct,
  getYouMayAlsoLike,
  resetYouMayAlsoLike,
} from '../actions/productsActions';
import { Row, Col, Button, Breadcrumb, BreadcrumbItem } from 'reactstrap';
import Benefits from './Benefits';
import { Helmet } from 'react-helmet';
import DidYouKnow from './DidYouKnow';
import { addToCart, addTotalQuantityToCart } from '../actions/shoppingCart';
import Slide from 'react-reveal';
import ButtonSpinner from './ButtonSpinner';
import Spinner from './Spinner';
import Reviews from './Reviews';
import { useHistory, useLocation, useParams } from 'react-router-dom';

const PageLink = (props: any) => {
  const { products, cart, auth, guest } = props;
  const history = useHistory();
  const location = useLocation() as any;
  const params = useParams() as any;

  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [benefits, setBenefits] = useState(null);
  const [didYouKnow, setDidYouKnow] = useState(null);
  const [didYouKnowImage, setDidYouKnowImage] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [showModal, setShowModal] = useState(false);
  const [product, setProduct] = useState<any>({});

  const prevLocationPathnameRef = useRef(location.pathname);
  const prevProductRef = useRef(products.product);

  const updateWindowDimensions = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  };

  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener('resize', updateWindowDimensions);

    if (location.state === undefined) {
      props.getSingleProduct(params.productid);
    }
    if (location.state !== undefined && location.state.product) {
      props.getYouMayAlsoLike(location.state.product);
      setProduct(location.state.product);
      setBenefits(location.state.product.benefits);
      setDidYouKnow(location.state.product.didYouKnow);
      setDidYouKnowImage(location.state.product.didYouKnowImage);
    }

    return () => {
      window.removeEventListener('resize', updateWindowDimensions);
      props.resetYouMayAlsoLike();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (location.pathname !== prevLocationPathnameRef.current) {
      prevLocationPathnameRef.current = location.pathname;
      setProduct({});
      props.getSingleProduct(params.productid);
    }
  });

  useEffect(() => {
    if (products.product !== prevProductRef.current) {
      prevProductRef.current = products.product;
      props.getYouMayAlsoLike(products.product);
      setProduct(products.product);
      setBenefits(products.product.benefits);
      setDidYouKnow(products.product.didYouKnow);
      setDidYouKnowImage(products.product.didYouKnowImage);
    }
  });

  const handleNutrition = () => {
    setShowModal((prev) => !prev);
  };

  const adjustCart = () => {
    if (cart.addToCartLoading.productId !== product._id) {
      const totalQuantity = quantity;
      if (auth.isAuthenticated) {
        props.addTotalQuantityToCart(product, totalQuantity, auth.user.id);
      } else {
        props.addTotalQuantityToCart(product, totalQuantity, guest.userid || undefined);
      }
    }
    setQuantity(1);
  };

  const handlePlusClick = () => {
    setQuantity((prev) => prev + 1);
  };

  const handleMinusClick = () => {
    if (quantity > 1) {
      setQuantity((prev) => prev - 1);
    }
  };

  const handleProductRoute = (prod) => {
    history.push({
      pathname: `/shop/${prod.name.replace(/[^A-Z0-9]+/gi, '-')}/${prod._id}`,
    });
  };

  return (
    <div>
      <div>
        <Helmet>
          <title>
            {location.state !== undefined && location.state.product
              ? location.state.product.name
              : params.title.replace(/-/g, ' ')}{' '}
            - Frozberries Victoria
          </title>
          <meta
            name="description"
            content={`${
              location.state !== undefined && location.state.product
                ? location.state.product.name + '-' + location.state.product.description
                : params.title.replace(/-/g, ' ')
            } - Frozberries Victoria`}
          />
        </Helmet>
      </div>
      {products.singleProductLoading && (
        <div className="text-center">
          <Spinner />
        </div>
      )}
      {Object.keys(product).length > 0 && (
        <React.Fragment>
          <Row className="mt-3">
            <Col>
              <div>
                <Breadcrumb className="mx-5">
                  <BreadcrumbItem style={{ cursor: 'pointer' }} onClick={() => history.push('/')}>
                    Home
                  </BreadcrumbItem>
                  <BreadcrumbItem style={{ cursor: 'pointer' }} onClick={() => history.goBack()}>
                    Shop
                  </BreadcrumbItem>
                  <BreadcrumbItem style={{ cursor: 'pointer' }} active>
                    {params.title.replace(/-/g, ' ')}
                  </BreadcrumbItem>
                </Breadcrumb>
              </div>
            </Col>
          </Row>
          <Row className=" py-5">
            <Col lg="6" className="text-center">
              <div style={{ paddingLeft: width > 992 && '10%' }}>
                <img
                  style={{ maxHeight: '600px' }}
                  src={product.image}
                  alt={product.name}
                  className="img-fluid px-2 py-2"
                />
              </div>
            </Col>
            <Col lg="6" className="px-5">
              <div style={{ paddingRight: width > 992 && '15%' }}>
                <h1>{product.name}</h1>
                <h3 className="py-2 text-muted font-weight-bold">${product.price.toFixed(2)}</h3>

                <div style={{ minHeight: '100px' }} className="border-top">
                  <p className="pt-3">{product.description}</p>
                  <p className="pt-1">Unit Size: {product.unitSize}</p>
                  <p className="pt-1">Country of origin: {product.origin}</p>
                  <p>
                    {cart.cart.map(
                      (each) =>
                        each.product._id === product._id && (
                          <Slide
                            key={each.product._id}
                            warning={
                              cart.cart.length === 0
                                ? false
                                : cart.cart.map((each) => each.product._id === product._id)
                                  ? true
                                  : false
                            }
                          >
                            <span
                              style={{ fontSize: '14px' }}
                              className={'font-weight-bold text-muted'}
                            >
                              +{each.quantity} Added
                            </span>
                          </Slide>
                        )
                    )}
                  </p>
                </div>

                {product.inStock ? (
                  <div>
                    <div className="text-center border-top border-bottom mt-5 py-3">
                      <h4>
                        {' '}
                        <i
                          onClick={handleMinusClick}
                          style={{ fontSize: '15px', color: 'rgb(14,35,87)', cursor: 'pointer' }}
                          className="fas fa-minus mr-3 text-muted"
                        />
                        {quantity}
                        <i
                          onClick={handlePlusClick}
                          style={{ fontSize: '15px', color: 'rgb(14,35,87)', cursor: 'pointer' }}
                          className="fas fa-plus ml-3 text-muted"
                        />
                      </h4>
                    </div>
                    <div>
                      <Button
                        onClick={adjustCart}
                        color="success"
                        className="btn-block mt-4 py-3"
                        style={{ height: '60px' }}
                      >
                        {cart.addToCartLoading.productId === product._id ? (
                          <ButtonSpinner />
                        ) : (
                          '    Add to Cart'
                        )}
                      </Button>
                    </div>
                  </div>
                ) : (
                  <div>
                    <h5 className="text-danger font-weight-bold">Currently out of stock</h5>
                  </div>
                )}
              </div>
            </Col>
          </Row>

          <Benefits product={product} />
          <DidYouKnow didYouKnow={didYouKnow} didYouKnowImage={didYouKnowImage} />

          <div className="container">
            <Row>
              <Col>
                <Reviews product={product} />
              </Col>
            </Row>
          </div>

          {products.youMayAlsoLike.length > 0 && (
            <div>
              <h1 className="text-center">YOU MAY ALSO LIKE</h1>
              <Row className="youMayAlsoLike py-5">
                {products.youMayAlsoLike.map((prod) => (
                  <Col md="4" sm="6" xs="12" key={prod._id} className=" text-center  item my-2">
                    <div
                      className="img-outer "
                      style={{ cursor: 'pointer' }}
                      onClick={() => handleProductRoute(prod)}
                    >
                      <div className="position-relative">
                        <img
                          style={{ maxHeight: 300 }}
                          className="img-fluid product-image"
                          src={prod.image}
                          alt={prod.name}
                        />
                      </div>
                    </div>
                    <div>
                      <h5 className="pt-3">{prod.name}</h5>
                    </div>
                    <div>
                      <h5
                        className="font-weight-bold d-inline"
                        style={{ fontSize: '17px', color: 'rgb(236,23,79)' }}
                      >
                        <span className={'text-center'}>${prod.price.toFixed(2)}</span>
                      </h5>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          )}
        </React.Fragment>
      )}
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  products: state.products,
  cart: state.cart,
  auth: state.form,
  guest: state.guest,
});

export default connect(mapStateToProps, {
  resetYouMayAlsoLike,
  getYouMayAlsoLike,
  getSingleProduct,
  addToCart,
  addTotalQuantityToCart,
})(PageLink);
